import ChevronLeftIconPath from "@ingka/ssr-icon/paths/chevron-left";

export default ChevronLeftIconPath;
